import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  LoggingService,
  TimePeriod,
} from "app/shared";
import { ChartDefinitions, ChartDefinition } from "../../../chartDefinitions.config";
import { BaseDetailsLogic } from "app/analytics/BaseDetailsLogic";
import { AnnotationsSentConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { TooltipCoordinatorService } from "app/analytics/services/tooltip-coordinator.service";

@Component({
  selector: "annotations-sent-details",
  templateUrl: "./annotations-sent-details.component.html",
  standalone: false,
})
export class AnnotationsSentDetailsComponent
  extends BaseDetailsLogic<AnnotationsSentConfig>
  implements OnInit, OnDestroy
{

  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    tooltipCoordinator: TooltipCoordinatorService
  ) {
    super(analyticsService, authService, loggingService, AnnotationsSentConfig, tooltipCoordinator);
  }

  get selectedTimePeriod(): string | TimePeriod {
    return this.config?.period as TimePeriod;
  }

  set selectedTimePeriod(value: string | TimePeriod) {
    this.config.period = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }

  protected getInfoTexts(): { [key: string]: string } {
    return {
      timePeriod:
        "Pick a time period to see which annotations were sent during that range. For example, you can look at annotations sent in the last week, month, or year. This helps you understand when people are sharing or sending annotations the most.",
    };
  }
}
